"use client";

import { c as _c } from "react/compiler-runtime";
import AppointmentLocationPrompt from "@/components/location/appointment-location-prompt";
import { useAppointmentLocationPromptStore } from "@/stores/appointment-location-prompt-store";

/**
 * Mounted once in the console layout so a location prompt requested by a
 * flow that navigates away (see `requestLocationPrompt`) survives the move.
 */
export default function GlobalAppointmentLocationPrompt() {
  const $ = _c(4);
  const request = useAppointmentLocationPromptStore(_temp);
  if (!request) {
    return null;
  }
  let t0;
  if ($[0] !== request.appointmentId || $[1] !== request.locationId || $[2] !== request.requestId) {
    t0 = <AppointmentLocationPrompt key={request.requestId} locationId={request.locationId} appointmentId={request.appointmentId} />;
    $[0] = request.appointmentId;
    $[1] = request.locationId;
    $[2] = request.requestId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
function _temp(state) {
  return state.request;
}